import F84Game from "../Game";
import Scene from "./Scene";

export default class AsyncImage extends Phaser.GameObjects.Image
{
    private static _BATCH_UUID = 0;
    public static readonly LOAD_COMPLETE = "load-complete";

    private _scene:Scene;
    private _texture:string;
    private _frame?:string|number;
    private _status:"loading"|"loaded"|"error";
    public get status():"loading"|"loaded"|"error" { return this._status; }

    constructor(scene:Scene, x:number, y:number, path:string, texture:string, frame?:string|number, hasLowQuality?:boolean)
    {
        super(scene, x, y, '');
        this._scene = scene;
        // One frame delay so we can add our listener in time
        this._scene.events.once(Phaser.Scenes.Events.PRE_UPDATE, ()=>{
            this.loadTexture(path, texture, frame, hasLowQuality);
        }, this);
        this._scene.events.on(Phaser.Scenes.Events.SHUTDOWN, this.onShutdown, this);
    }

    public loadTexture(path:string, texture:string, frame?:string|number, hasLowQuality?:boolean):void
    {
        this._status = "loading";
        this._texture = texture;
        this._frame = frame;

        if(this.scene.game.textures.exists(this._texture))
        {
            this._status = "loaded";
            this.setTexture(this._texture, this._frame);
            this.emit(AsyncImage.LOAD_COMPLETE);
        }
        else
        {
            // By using load batches we are able to hook into all our other necessary code and auto-unload these on scene exit without independent management
            const loadBatch = F84Game.Instance.loadBatches.get(this._texture + AsyncImage._BATCH_UUID);
            loadBatch.addImage(this._texture, path, hasLowQuality);
            loadBatch.destroyOnUnload = true;
            AsyncImage._BATCH_UUID++;
            loadBatch.load(this._scene);
            // We need to add this listener immediately after we call load to prevent our listener being called prior to any low quality image overrides
            this._scene.load.on(Phaser.Loader.Events.FILE_COMPLETE, this.onFileLoaded, this);
            this._scene.load.start();
        }
    }

    private onFileLoaded(key:string):void
    {
        if(key==this._texture)
        {
            this._status = "loaded";
            if(this.scene){
                this.setTexture(this._texture, this._frame);
                this.emit(AsyncImage.LOAD_COMPLETE);
            }
            this._scene.load.off(Phaser.Loader.Events.FILE_COMPLETE, this.onFileLoaded, this);
        }
    }

    onShutdown(): void {
        this._scene.load.off(Phaser.Loader.Events.FILE_COMPLETE, this.onFileLoaded, this);
        this._scene.events.off(Phaser.Scenes.Events.SHUTDOWN, this.onShutdown, this);
    }
}